import {createBreakpoint} from 'react-use'

export const useMobile = createBreakpoint({isMobile: 300, isDesktop: 600})